"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var CodebookItem_1 = require("../../core/model/codebook/CodebookItem");
/**
 * <p>
 * This entity represents type of price list as code book item. A few facts:
 * </p>
 *
 * <ul>
 *      <li>Types of price list can be statically defined for some clients, because may not be possible to do it automatically due to nature
 *        of client data.</li>
 *      <li>There should be only one price list type for each priority of price lists, thus priority can be used as identification
 *        (external id) of the price list type.</li>
 * </ul>
 *
 * <p>
 * List of types is primarily statically defined based on documents describing price list settings (see an example within LOG-4521). Due
 * to automation of import (so we can import every price list), we automatically create unknown price list type with title set to priority
 * value. Types created this way will not be used automatically, which is intended.
 * </p>
 *
 * @author RV
 * @author VRu
 */


var PriceListType =
/*#__PURE__*/
function (_CodebookItem_1$Codeb) {
  _inherits(PriceListType, _CodebookItem_1$Codeb);

  /**
   * @param id internal id of code book
   * @param title the title of price list type
   * @param externalId the external id, it is required identification for this code book implementation
   */
  function PriceListType(id, title, externalId) {
    var _this;

    _classCallCheck(this, PriceListType);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceListType).call(this, id, title, null, immutable_1.List(), externalId));
    _this.id = id;
    _this.title = title;
    _this.externalId = externalId;
    return _this;
  }

  return PriceListType;
}(CodebookItem_1.CodebookItem);

exports.PriceListType = PriceListType;
/** Name of code book for generic code book API. */

PriceListType.CODEBOOK_NAME = 'pricelists.types';